import { Theme } from '../types';

export const lavenderTheme: Theme = {
  name: 'lavender',
  colors: {
    gray: {
      50: '#faf7ff',
      100: '#f3ecff',
      200: '#e9d5ff',
      300: '#d8b4fe',
      400: '#c084fc',
      500: '#a855f7',
      600: '#9333ea',
      700: '#7c3aed',
      800: '#6b21a8',
      900: '#581c87',
    },
    accent: {
      50: '#fefce8',
      100: '#fef9c3',
      200: '#fef08a',
      300: '#fde047',
      400: '#facc15',
      500: '#eab308',
      600: '#ca8a04',
      700: '#a16207',
      800: '#854d0e',
      900: '#713f12',
    },
    semantic: {
      success: '#10b981',
      successLight: '#d1fae5',
      error: '#ef4444',
      errorLight: '#fee2e2',
      warning: '#f59e0b',
      warningLight: '#fef3c7',
      info: '#8b5cf6',
      infoLight: '#ede9fe',
    },
    background: {
      app: '#faf7ff',
      surface: '#ffffff',
      elevated: '#ffffff',
      navbar: '#ffffff',
      sidebar: '#f3ecff',
      hover: '#f3ecff',
      active: '#e9d5ff',
      blueprint: 'linear-gradient(135deg, #faf7ff 0%, #e9d5ff 100%)',
    },
    text: {
      primary: '#581c87',
      secondary: '#6b21a8',
      tertiary: '#7c3aed',
      disabled: '#d8b4fe',
      inverse: '#ffffff',
      accent: '#a16207',
      onAccent: '#ffffff',
      muted: '#9333ea',
    },
    border: {
      color: '#e9d5ff',
      light: '#f3ecff',
      medium: '#d8b4fe',
    },
    button: {
      bg: '#faf7ff',
      bgHover: '#f3ecff',
      bgActive: '#e9d5ff',
      text: '#7c3aed',
      border: '#d8b4fe',
      primary: {
        bg: '#a855f7',
        bgHover: '#9333ea',
        bgActive: '#7c3aed',
        text: '#ffffff',
      },
      disabled: {
        bg: '#f3ecff',
        text: '#d8b4fe',
        border: '#e9d5ff',
      },
    },
    input: {
      bg: '#ffffff',
      border: '#d8b4fe',
      borderHover: '#c084fc',
      borderFocus: '#a855f7',
      text: '#581c87',
      placeholder: '#d8b4fe',
    },
    toggle: {
      bg: '#d8b4fe',
      bgActive: '#a855f7',
      thumb: '#ffffff',
    },
    executing: '#f59e0b',
    focus: '#a855f7',
    overlay: {
      light: 'rgba(88, 28, 135, 0.1)',
      medium: 'rgba(88, 28, 135, 0.2)',
      heavy: 'rgba(88, 28, 135, 0.3)',
      white: 'rgba(255, 255, 255, 0.1)',
    },
    shadow: {
      medium: 'rgba(168, 85, 247, 0.15)',
    },
  },
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    xxl: '48px',
    // Legacy spacing
    small: '8px',
    medium: '16px',
    large: '24px',
  },
  typography: {
    fontFamily: "'Inter', 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif",
    fontSize: {
      xs: '12px',
      sm: '14px',
      base: '16px',
      lg: '18px',
      xl: '20px',
      xxl: '24px',
      xxxl: '30px',
    },
    fontWeight: {
      normal: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
    },
    text: {
      xs: '12px',
      small: '14px',
      medium: '16px',
    },
  },
  borderRadius: {
    sm: '6px',
    md: '10px',
    lg: '16px',
    full: '9999px',
    // Legacy border radius
    small: '3px',
    medium: '8px',
  },
  shadows: {
    xs: '0 1px 2px 0 rgba(168, 85, 247, 0.05)',
    sm: '0 1px 3px 0 rgba(168, 85, 247, 0.08), 0 1px 2px -1px rgba(168, 85, 247, 0.08)',
    md: '0 4px 6px -1px rgba(168, 85, 247, 0.08), 0 2px 4px -2px rgba(168, 85, 247, 0.08)',
    lg: '0 10px 15px -3px rgba(168, 85, 247, 0.08), 0 4px 6px -4px rgba(168, 85, 247, 0.08)',
    xl: '0 20px 25px -5px rgba(168, 85, 247, 0.08), 0 8px 10px -6px rgba(168, 85, 247, 0.08)',
  },
  zIndex: {
    dropdown: 100,
    sticky: 200,
    overlay: 500,
    modal: 1000,
    toast: 2000,
    // Legacy z-index
    base: 0,
    accent: 5,
    content: 10,
    floating: 20,
  },
  transitions: {
    fast: '150ms cubic-bezier(0.4, 0, 0.2, 1)',
    base: '200ms cubic-bezier(0.4, 0, 0.2, 1)',
    slow: '300ms cubic-bezier(0.4, 0, 0.2, 1)',
  },
  breakpoints: {
    xs: '480px',
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px',
    xxl: '1536px',
  },
};


